import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { ActionList, Popover, DatePicker, Button } from '@shopify/polaris';
import { calculateDays } from 'utils'

const propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    })
  ),


  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  
  defaultDateOptionValue:  PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

const defaultProps = {
  disbaled: false,
  loading: false,
}

const DateActionList = (props) => {
  const currentDateTime = new Date()
  const beginingOfDay = currentDateTime.setHours(0,0,0,0);

  // ============== useStates ==============
  const [selectedOption, setSelectedOption] = useState( props.defaultDateOptionValue ? props.options.find( (opt) => opt.value == props.defaultDateOptionValue ) : props.options[0] );
  const oasndoisa = props.options.find( (opt) => opt.value == props.defaultDateOptionValue );
  const [isOpen, setIsOpen] = useState(false);

  const [{month, year}, setDate] = useState({month: currentDateTime.getUTCMonth(), year: currentDateTime.getUTCFullYear()}); // DatePicker month/year view
  const [selectedDates, setSelectedDates] = useState({ // DatePicker selected values
    start: new Date(beginingOfDay),
    end: new Date(beginingOfDay),
  });
  

  const toggleActive = useCallback(() => setIsOpen((active) => !active), []); // Popover toggle

  // Get the value and filter (via parent callback)
  const handleDateFilter = (selectedDateOption) => { 
    setSelectedOption(selectedDateOption);
    setIsOpen(false);

    props.onChange(selectedDateOption.value, selectedDateOption.label);
  }

  // Custom dates functions
  const handleMonthChange = useCallback( (month, year) => setDate({month, year}), [],);

  const handleDateSelection = (values) => {
    setSelectedDates(values);
    const dateLabel = calculateDays(values.start, values.end)
    setSelectedOption({ label: dateLabel, value: "date_range" });

    props.onChange("date_range", dateLabel, values);
  }

  // const dateOptionsToActionList = useCallback( () =>  props.options.map( (dateItem) => ({ content: dateItem.label, onAction: (O) => handleDateFilter(dateItem) }) ), [] ); // Get options from props
  // const dateFilterOptions = dateOptionsToActionList();
  const dateFilterOptions = props.options.map( (dateItem) => ({ content: dateItem.label, onAction: (O) => handleDateFilter(dateItem) }) ); // Get options from props

  return (
    <Popover 
      active={isOpen} 
      activator={ <Button disabled={ props.disabled || props.loading } onClick={toggleActive} disclosure>{ selectedOption.label }</Button> } 
      onClose={toggleActive}  
      fluidContent={true}>
      <Popover.Section>
        <ActionList items={ dateFilterOptions } />
      </Popover.Section>
      <Popover.Section>
        <DatePicker
          month={ month }
          year={ year }
          onChange={ handleDateSelection }
          onMonthChange={ handleMonthChange }
          selected={ selectedDates }
          allowRange
        />
      </Popover.Section>
    </Popover>
  )
};

DateActionList.propTypes = propTypes;
DateActionList.defaultProps = defaultProps;

export default DateActionList;